<template>
	<div>
		<navigation msg="订单管理/订单信息" />
		<router-view></router-view>
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/order/home.vue